(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('ContratosService', ContratosService);

  ContratosService.$inject = [
    '$http'
  ];

  // eslint-disable-next-line max-lines-per-function
  function ContratosService($http) {
    return {
      list,
      listItems,
      assignGlebas
    };

    function list({ propriedade = null, safra = null, atividade = null, gleba = null }) {
      return $http.get(`${SERVER}v1/contratos`, {
        params: { propriedade, safra, atividade, gleba }
      });
    }

    function listItems({ propriedade = null, safra = null, atividade = null, gleba = null }) {
      return $http.get(`${SERVER}v1/contrato_itens`, {
        params: { propriedade, safra, atividade, gleba }
      });
    }

    function assignGlebas(id, gleba_ids) {
      return $http.patch(`${SERVER}v1/contrato_itens/${id}`, { contrato_item: { gleba_ids } });
    }
  }
}());
